<script>
    import Icon from '../components/Icon.svelte';
    import { useNavigate } from 'svelte-navigator';

    const navigate = useNavigate()

    export let mode;
    export let setMode;
</script>

<div class="row bottom-nav padding-10 d-flex">
    <a
        href="#"
        class="w-25"
        class:active={mode == 'dialScreen'}
        on:click={() => setMode('dialScreen')}
    >
        <Icon icon="slack" color={mode == 'dialScreen' ? '#0E99D2' : '#A7B4BE'} />
        <span> Dial Pad</span>
    </a>
    <a
        href="#"
        class="w-25"
        class:active={mode == 'callLogs'}
        on:click={() => setMode('callLogs')}
    >
        <Icon icon="call-history" color={mode == 'callLogs' ? '#0E99D2' : '#A7B4BE'} />
        <span> Call logs</span>
    </a>
    <a
        href="#"
        class="w-25"
        class:active={mode == 'contactList'}
        on:click={() => setMode('contactList')}
    >
        <Icon icon="contact-list" color={mode == 'contactList' ? '#0E99D2' : '#A7B4BE'} />
        <span> Contacts</span>
    </a>
    <a
        href="#"
        class="w-25"
        class:active={mode == 'messages'}
        on:click={() => navigate('/channels')}
    >
        <Icon icon="add-note" color={mode == 'messages' ? '#0E99D2' : '#A7B4BE'} />
        <span> Messages</span>
    </a>
    <a
        href="#"
        class="w-25"
        class:active={mode == 'userSettings'}
        on:click={() => setMode('userSettings')}
    >
        <Icon icon="settings" color={mode == 'userSettings' ? '#0E99D2' : '#A7B4BE'} />
        <span> Settings</span>
    </a>
</div>

<style lang="scss">
    .bottom-nav {
        background-color: #fafdff;
        justify-content: space-evenly;
        padding-top: 16px;
        padding-bottom: 16px;
        margin-top: auto;
        a {
            color: #a7b4be;
            font-size: 12px;
            margin-top: 5px;
            font-weight: 500;
        }
        a.active {
            color: #0e99d2;
            font-weight: 700;
        }
        .w-25 {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 5px;
        }
    }
</style>
